export default __webpack_public_path__ + "assets/banner_1024x2048.webp";